// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.caroimg {
    width: 100%;
    height: 580px;
    object-fit:cover;
    object-position:50% 50%;
    /* filter: brightness(50%);
    -webkit-filter: brightness(50%);
    -moz-filter: brightness(50%);
    -o-filter: brightness(50%);
    -ms-filter: brightness(50%); */
   
}

.child2 {
    
    position: relative;
    top: -400px;
    height: 0px;
    color: #fff;
    align-items: center;
    text-align: center;
    
}

ol li {
    font-weight:bold;
}
li > p {
    font-weight:normal;
}

.herotext {
    font-size: 20px; 
    text-align: justify; 
    margin-left: 100px; 
    margin-right: 100px
}


@media (min-width: 100px) and (max-width: 567px){
    .caroimg {
        height: 120vh;
        
    }
    
    .child2 {
        
        position: relative;
        top: -580px;
       
    }

    .herotext {
        margin-top: 5px;
        font-size: 20px; 
        text-align: justify; 
        margin-left: 20px; 
        margin-right: 20px
    }
    
    
} 


  `, "",{"version":3,"sources":["webpack://./src/components/Termsandconditions.css"],"names":[],"mappings":";;AAEA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,uBAAuB;IACvB;;;;kCAI8B;;AAElC;;AAEA;;IAEI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,kBAAkB;;AAEtB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;;AAGA;IACI;QACI,aAAa;;IAEjB;;IAEA;;QAEI,kBAAkB;QAClB,WAAW;;IAEf;;IAEA;QACI,eAAe;QACf,eAAe;QACf,mBAAmB;QACnB,iBAAiB;QACjB;IACJ;;;AAGJ","sourcesContent":["\n\n.caroimg {\n    width: 100%;\n    height: 580px;\n    object-fit:cover;\n    object-position:50% 50%;\n    /* filter: brightness(50%);\n    -webkit-filter: brightness(50%);\n    -moz-filter: brightness(50%);\n    -o-filter: brightness(50%);\n    -ms-filter: brightness(50%); */\n   \n}\n\n.child2 {\n    \n    position: relative;\n    top: -400px;\n    height: 0px;\n    color: #fff;\n    align-items: center;\n    text-align: center;\n    \n}\n\nol li {\n    font-weight:bold;\n}\nli > p {\n    font-weight:normal;\n}\n\n.herotext {\n    font-size: 20px; \n    text-align: justify; \n    margin-left: 100px; \n    margin-right: 100px\n}\n\n\n@media (min-width: 100px) and (max-width: 567px){\n    .caroimg {\n        height: 120vh;\n        \n    }\n    \n    .child2 {\n        \n        position: relative;\n        top: -580px;\n       \n    }\n\n    .herotext {\n        margin-top: 5px;\n        font-size: 20px; \n        text-align: justify; \n        margin-left: 20px; \n        margin-right: 20px\n    }\n    \n    \n} \n\n\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
